import { TPlugin } from '@/models/plugin'

export const PluginCode = {
  Coupon: 'CU',
  Report: 'RPT',
  Smaregi: 'SMR',
  CleaningManager: 'CM',
  GuestApp: 'GUE',
  GuestAppAssetCustom: 'GAC',
  GuestAppDesign: 'GAD',
  ReservationTLLincoln: 'TL',
  ReservationTLLincolnTwoWay: 'TT',
  ReservationNeppan: 'NP',
  ReservationNeppanTwoWay: 'NPT',
  ReservationTemairazu: 'TM',
  ReservationTemairazuTwoWay: 'TMT',
  ReservationChillnn: 'CN',
  ReservationTripla: 'TRIPLA',
  ReservationRakutsu: 'RK',
  ReservationRakutsuForToyo: 'RK_TOYO',
  MailDelivery: 'MD',
  MailDeliveryForSMS: 'DELIVERY_SMS',
  SmartKey: 'SK',
  SpaceManagement: 'SPM',
  PaymentTerminal: 'PAYMENT_TERMINAL',
  CustomCheckin: 'CC',
  CheckinTimeSelection: 'CHECKIN_TIME_SELECTION',
  MiwaLock: 'MWL',
  PmsCardKey: 'PMS_CARD_KEY',
  Goal: 'GOAL',
  Legend: 'LEGEND',
  Payment: 'PA',
  CallingOperator: 'CALLING_OPERATOR',
  ReservationTriplaTwoWay: 'TRIPLA_TWO_WAY',
  CTI: 'CTI',
  ReservationTask: 'RESERVATION_TASK',
} as const
export type PluginCode = (typeof PluginCode)[keyof typeof PluginCode]

export const setHasRoomManagerPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'RM')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasSalesManagerPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'SM')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasCustomCheckinPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'CC')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasTlTwoWayPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'TT')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasMobileRequestPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'MR')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasTicketPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'TKT')
    return result.length !== 0
  }
}

export const setHasPrinterPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'PRT')
    return result.length !== 0
  }
}

export const setHasPaymentPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'PA')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasRemoteLockPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'RL')
    if (result.length !== 0) {
      return true
    }

    if (result.length === 0) {
      return false
    }
  }
}

export const setHasSelfCheckinPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'SC')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasRepeatPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'RP')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasCleaningManagerPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'CM')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasAccountingInterlockingPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'AI')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasReservationAnalysisPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'RA')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const setHasSmartKeyPlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'SK')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }

  return false
}

export const setHasMiwaLockPlugin: (plugins: TPlugin[]) => boolean = (plugins: TPlugin[]) => {
  if (plugins) {
    const result = plugins.filter((element: TPlugin) => element.code === 'MWL')
    return result.length !== 0
  }

  return false
}

// 管理画面（対面）でのカードキー発行・読取りの主体となるプラグイン。美和固有の処理は setHasMiwaLockPlugin で別途判定する。
// SK は手動・キーレス専用のため対面発行の判定には使わない
export const setHasPmsCardKeyPlugin = (plugins: TPlugin[]): boolean => checkActivePlugin(plugins, PluginCode.PmsCardKey)

export const setHasNotPaymentSalePlugin = plugins => {
  if (plugins) {
    const result = plugins.filter(element => element.code === 'NPS')
    if (result.length !== 0) {
      return true
    }
    if (result.length === 0) {
      return false
    }
  }
}

export const checkActivePlugin = (plugins, code: PluginCode) => {
  if (!plugins?.length || !code) return false

  return !!plugins.find(plugin => plugin.code === code)?.isEnabled
}

export const hasAnyReservationPlugin = (plugins): boolean => {
  return (
    checkActivePlugin(plugins, PluginCode.ReservationTLLincoln) ||
    checkActivePlugin(plugins, PluginCode.ReservationNeppan) ||
    checkActivePlugin(plugins, PluginCode.ReservationTemairazu) ||
    checkActivePlugin(plugins, PluginCode.ReservationChillnn) ||
    checkActivePlugin(plugins, PluginCode.ReservationTripla) ||
    checkActivePlugin(plugins, PluginCode.ReservationRakutsu) ||
    checkActivePlugin(plugins, PluginCode.ReservationRakutsuForToyo)
  )
}

/**
 * 設定「チェックイン・アウト」の「チェックイン」タブ（共通・事前チェックイン・セルフチェックイン）を表示するか
 * 共通・事前チェックインはゲストアプリの事前チェックインでも使う設定のため、セルフチェックインが無くても予約連携があれば対象にする。
 * 予約連携の判定は、ゲストアプリの事前チェックインのトップ画面（予約検索あり/なし）と同じにする仕様
 */
export const canUseCheckinSetting = (plugins: TPlugin[] | undefined): boolean => {
  return Boolean(setHasSelfCheckinPlugin(plugins)) || hasAnyReservationPlugin(plugins)
}

/**
 * タスク管理（予約の新規・更新・キャンセルの一覧）を使えるか
 * 予約タスク管理プラグインだけでは予約を取り込めないため、対象のサイトコントローラーも有効なことを条件にする（API も同じ条件）
 * tripla / CHILLNN / らく通 TOYO は初期リリースの対象外のため、hasAnyReservationPlugin より対象が狭い
 */
export const hasReservationTaskPlugin = (plugins: TPlugin[] | undefined): boolean => {
  return (
    checkActivePlugin(plugins, PluginCode.ReservationTask) &&
    (checkActivePlugin(plugins, PluginCode.ReservationTLLincoln) ||
      checkActivePlugin(plugins, PluginCode.ReservationTemairazu) ||
      checkActivePlugin(plugins, PluginCode.ReservationNeppan) ||
      checkActivePlugin(plugins, PluginCode.ReservationRakutsu))
  )
}

/**
 * セルフチェックインのカード発行機（aipass-ci-card-writer）を使うカードキー連携が有効か
 * backend の HotelPlugin::hasCardReaderPlugin() と対象を揃える
 */
export const hasCardReaderPlugin = (plugins: TPlugin[] | undefined): boolean => {
  return (
    checkActivePlugin(plugins, PluginCode.MiwaLock) ||
    checkActivePlugin(plugins, PluginCode.Goal) ||
    checkActivePlugin(plugins, PluginCode.Legend)
  )
}

export const hasMailDeliveryPlugin = plugins => {
  return checkActivePlugin(plugins, PluginCode.MailDelivery)
}

export const hasSpaceVisibility = (plugins): boolean => {
  return checkActivePlugin(plugins, PluginCode.SpaceManagement) || checkActivePlugin(plugins, PluginCode.CheckinTimeSelection)
}

/** 在庫連携（two-way）対応のサイトコントローラーが有効か */
export const hasSiteControllerTwoWayPlugin = (plugins): boolean => {
  return (
    checkActivePlugin(plugins, PluginCode.ReservationTLLincolnTwoWay) ||
    checkActivePlugin(plugins, PluginCode.ReservationNeppanTwoWay) ||
    checkActivePlugin(plugins, PluginCode.ReservationTemairazuTwoWay)
  )
}
